import { forwardRef, type Ref, type SVGProps } from "react";
const IconUploadFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M28 22a2 2 0 0 0-2 2v2H6v-2a2 2 0 0 0-4 0v3.5A2.5 2.5 0 0 0 4.5 30h23a2.5 2.5 0 0 0 2.5-2.5V24a2 2 0 0 0-2-2"
    />
    <path
      fill="currentColor"
      d="M18.17 3a3 3 0 0 0-4.34 0L8.54 8.64a2 2 0 0 0 2.92 2.72L14 8.64V21a2 2 0 0 0 4 0V8.64l2.54 2.72a2 2 0 1 0 2.92-2.72z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconUploadFilledSVG);
ForwardRef.displayName = "IconUploadFilled";
export { ForwardRef as IconUploadFilled };
